"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridExpandableCell = void 0;
const react_1 = __importStar(require("react"));
const ArrowIcon_1 = require("../../../ArrowIcon");
const common_1 = require("../../../common");
const GridExpandableCell_styles_1 = require("./GridExpandableCell.styles");
const StackView_1 = require("../../../StackView");
exports.GridExpandableCell = react_1.default.memo(function GridExpandableCell({ isExpandable, isExpanded, onClick, children, depth }) {
    const direction = (0, react_1.useMemo)(() => (isExpanded ? common_1.ARROW_DIRECTION.down : common_1.ARROW_DIRECTION.right), [isExpanded]);
    return (react_1.default.createElement(GridExpandableCell_styles_1.StyledGridExpandableCell, { depth: depth, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.start },
        isExpandable && (react_1.default.createElement(GridExpandableCell_styles_1.StyledGridExpandableCellButton, { type: "button", "data-selector-id": "grid-expand-control", onClick: onClick },
            react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: direction }))),
        react_1.default.createElement(GridExpandableCell_styles_1.StyledGridExpandableCellWrapper, null, children)));
});
//# sourceMappingURL=GridExpandableCell.js.map